export default __webpack_public_path__ + "static/there-7ad5ff0908352f25cd89eb87653187ea.png";